/**
 * Role-related translations for Chinese (Simplified) language
 * This file contains translations for role names and descriptions
 */
export default {
  roles: {
    merlin: '梅林',
    merlinPure: '终极梅林',
    guinevere: '女皇',
    percival: '派西维尔',
    tristan: '特里斯坦',
    isolde: '伊索德',
    troublemaker: '麻烦友',
    servant: '仆人',
    goodLancelot: '正义-兰斯洛特',
    evilLancelot: '邪恶-兰斯洛特',
    lancelots: '兰斯洛特',
    mordred: '莫德雷德',
    trickster: '骗子',
    morgana: '莫甘娜',
    oberon: '奥伯伦',
    lunatic: '疯子',
    brute: '野蛮人',
    witch: '巫婆',
    minion: '士兵',
    cleric: '牧师',
    revealer: '被揭示者',
    role: '角色',
    unknown: '未知角色',
    mysteryWizard: '神秘法师',
    unknownLancelot: '未知兰斯洛特',
    wraith: '幽灵',
  },
  rolesInfo: {
    roles: '角色',
    inGameRoles: '游戏中的角色',
    visibleRoles: '你可见的角色',
    merlinInfo: '知道谁是坏人方,必须保持隐藏',
    merlinPureInfo: '知道谁是坏人方及角色,必须保持隐藏',
    percivalInfo: '看到两位角色(梅林/莫甘娜),但不知道谁是真正的梅林',
    servantInfo: '亚瑟王的忠实仆人',
    troublemakerInfo: '不得不对他的忠诚度撒谎',
    guinevereInfo: '看到两位角色(兰斯洛特),但不知道谁是真正的兰斯洛特',
    goodLancelotInfo: '好人方的兰斯洛特,可以从角色转为坏人方',
    evilLancelotInfo: '坏人方的兰斯洛特,可以从角色转为好人方',
    mordredInfo: '梅林不知道你是坏人方',
    morganaInfo: '扮演梅林,混淆派西维尔',
    oberonInfo: '其他坏人方不知道你是坏人方',
    minionInfo: '莫德雷德的爪牙',
    isoldeInfo: '恋人,知道谁是特里斯坦,必须保持隐藏',
    tristanInfo: '恋人,知道谁是伊索德,必须保持隐藏',
    evilInfo: '角色未知的坏人方玩家',
    goodInfo: '角色未知的好人方玩家',
    tricksterInfo: '对他的忠诚撒谎',
    lunaticInfo: '每个任务都必须失败',
    bruteInfo: '可能只会失败前三个任务',
    witchInfo: '可以隐藏一次任务的结果，但这会给一个随机玩家忠诚检测',
    revealerInfo: '在第二次任务失败后揭露自己',
    clericInfo: '知道第一次任务领导者的忠诚情况。必须保持隐藏',
    unknownInfo: '未知角色',
    mysteryWizardInfo: '两个玩家之一是好人方的(梅林)还是坏人的(莫甘娜)',
    unknownLancelotInfo: '兰斯洛特,谁的忠诚无人知晓',
    wraithInfo: '坏人方和梅林都不知道你的存在',
  },
};
